import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Badge } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonButton from '../components/CommonButton';
import CommonButtonBadge from '../components/CommonButtonBadge';
import CommonDropdown from '../components/CommonDropdown';
import CommonPagination from '../components/CommonPagination';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

import { OptionsConstants as options } from '../../config/constants/OptionsConstants';

class DataTableEB04DataCourse extends Component {

    render() {

        let props = this.props;

        let { onSetEdit, onNavigate, onDropDownChange, onCheckDelete, onCheckDeleteAll, onPaginationChange } = props;

        let { Action, DataTable, Inputs, Deletes, Operation, UserCookie, Masterbase } = props;

        let checkExternal = (["0","1","2","5"].includes(UserCookie?.types)) ? true : false;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;
        DataTable.rows.forEach(row => { deleteChecked++;});

        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />
                    
                    <Row>
                        <Col md={12}>
                            {DataTable?.rows?.length > 0 ? 
                                <Table 
                                        responsive 
                                        borderless 
                                        className={`table-advance table-responsive ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                                    >
                                    <thead>
                                        <tr>
                                            <th className="th-td-align-center th-width-150p th-font-sm">รหัสหลักสูตร</th>
                                            <th className="th-width-auto th-font-sm">ชื่อหลักสูตร</th>
                                            <th className="th-td-align-center th-width-75p th-font-sm">รุ่นที่</th>
                                            {checkExternal && (
                                                <th className="th-td-align-left th-width-200p th-font-sm">ผู้เข้ารับการอบรม</th>
                                            )}
                                            <th className="th-td-align-left th-width-150p th-font-sm">วันที่อบรม</th>
                                            <th className="th-td-align-center th-width-150p th-font-sm">Pre-Test</th>
                                            <th className="th-td-align-center th-width-100p th-font-sm">Post-Test</th>
                                            <th className="th-td-align-center th-width-100p th-font-sm">สถานะการอบรม</th>
                                            <th className="th-td-align-center th-width-50p">
                                                {/* {deleteChecked > 0 && (
                                                    <Form.Check 
                                                        type="checkbox"
                                                        checked={Deletes.checkAll}
                                                        onChange={(e) => onCheckDeleteAll(e, fn.getCheckboxAllItem('deletes'))} 
                                                        className="checkbox-font-sm"
                                                    />
                                                )} */}
                                            </th>                                            
                                        </tr>                                   
                                    </thead>
                                    <tbody>
                                        {DataTable.rows.map((row, index) => {

                                            Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });
                                            
                                            rowId++;

                                            let del = true;

                                            return (
                                                <React.Fragment key={`${rowId}-${row.id}`}>
                                                    <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                        <td className="text-truncate td-font-sm" title={`${row.official_course_code}`}>
                                                            <Badge bg="success" size="md" className="badge-size-sm me-2">{row.official_course_code}</Badge>
                                                            {row.course_eb_01_name}
                                                        </td>
                                                        <td className="text-truncate td-font-sm" title={row.th_name}>{row.th_name}</td>
                                                        <td className="text-truncate td-font-sm th-td-align-center">
                                                            {row.model_no}
                                                        </td>
                                                        {checkExternal && (
                                                            <td className="text-truncate td-font-sm th-td-align-left " title={row.fullname}>
                                                                {row.fullname}
                                                                <p className="title-xs mb-0 mt-1">
                                                                    {(row.id && row.course_eb_01_id) && (
                                                                        <> <i className="fa-solid fa-rotate fa-light fa-solid fa-rotate fa-fw me-2"></i>
                                                                            เชื่อมโยงผู้ใช้งานภายนอก
                                                                        </>
                                                                    )}
                                                                </p>
                                                            </td>
                                                        )}
                                                        <td className="text-truncate td-font-sm th-td-align-center">                                                              
                                                            <p className="title-xs mb-0 mt-1">
                                                                <i className="fa-classic fa-light fa-calendar-star fa-fw me-2"></i>
                                                                {(() => {
                                                                    let { training_start_date, training_end_date } = row;

                                                                    if(util.isEmpty(training_end_date)){ 
                                                                        training_end_date = training_start_date; 
                                                                    }

                                                                    training_start_date = util.convertDateToBE(training_start_date);
                                                                    training_end_date = util.convertDateToBE(training_end_date);

                                                                    const start = util.parseDate(training_start_date);
                                                                    const end = util.parseDate(training_end_date);

                                                                    return util.displayDateRange(start, end);
                                                                })()}
                                                            </p>
                                                        </td>  
                                                        <td className="th-td-align-center">
                                                            {!row.pre_test ? "- / 10" : (row.pre_test + "/ 10")}              
                                                        </td>  
                                                        <td className="th-td-align-center">
                                                            {!row.post_test ? "- / 10" : (row.post_test + "/ 10")}    
                                                        </td> 
                                                        <td className="th-td-align-center">
                                                            <CommonDropdown
                                                                element="DataTable"
                                                                input={{id: 'course_status', value: row.course_status}}
                                                                option={{source: 'options', section: 'status', item: 'eb02_course_status'}}
                                                                size="sm"
                                                                disabled={true}
                                                            /> 
                                                        </td>
                                                        <td className="th-td-align-center">
                                                            {del && row.id &&(
                                                                <Form.Check 
                                                                    type="checkbox"
                                                                    name="deletes"
                                                                    value={row.id}
                                                                    checked={Deletes.deletes.includes(row.id)}
                                                                    onChange={(e) => onCheckDelete(e)} 
                                                                    className="checkbox-font-sm"
                                                                />
                                                            )}
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            )
                                        })}
                                    </tbody>
                                </Table>
                            :
                                <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                            }

                            {!Action.Loading.dataTable && (
                                <CommonPagination 
                                    Pagination={DataTable.pagination} 

                                    handlePagination={(paging) => onPaginationChange(paging)}
                                />
                            )}                               
                        </Col>
                    </Row>
            </Container>                            
                        
        );                
    }
}

export default DataTableEB04DataCourse;
